const ExamIcon = () => {
  return (
    <svg
      height="20"
      width="20"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g>
          {" "}
          <path
            style={{ fill: "currentColor" }}
            d="M294.433,172.655c0-0.451,0.151-1.051,0.3-1.651l27.94-91.632c1.653-5.258,8.412-7.812,15.322-7.812 s13.67,2.553,15.322,7.812l28.09,91.632c0.151,0.602,0.3,1.2,0.3,1.651c0,5.559-8.561,9.615-15.022,9.615 c-3.756,0-6.759-1.202-7.661-4.356l-5.107-18.777H322.22l-5.107,18.777c-0.902,3.154-3.905,4.356-7.661,4.356 C302.994,182.269,294.433,178.213,294.433,172.655z M348.961,141.108l-10.966-40.257l-10.966,40.257H348.961z"
          ></path>{" "}
          <path
            style={{ fill: "currentColor" }}
            d="M385.143,99.685V89.022h-10.662c-3.079,0-5.166-2.748-5.166-6.924c0-3.957,2.089-7.034,5.166-7.034 h10.662V64.512c0-2.638,3.077-5.275,7.034-5.275c4.177,0,6.925,2.637,6.925,5.275v10.552h10.552c2.638,0,5.277,3.077,5.277,7.034 c0,4.176-2.638,6.924-5.277,6.924h-10.552v10.663c0,3.077-2.748,5.165-6.925,5.165C388.22,104.851,385.143,102.763,385.143,99.685z "
          ></path>{" "}
          <path
            style={{ fill: "currentColor" }}
            d="M416.725,512H95.274c-29.149,0-52.864-23.715-52.864-52.865V116.121 c0-15.918,6.195-30.878,17.448-42.127l56.544-56.547c9.108-9.108,21.139-15.093,33.879-16.855C152.956,0.198,155.731,0,158.53,0 h258.194c29.149,0,52.864,23.715,52.864,52.865v272.618c0,8.162-6.619,14.781-14.781,14.781c-8.162,0-14.781-6.619-14.781-14.781 V52.865c0-12.848-10.452-23.303-23.301-23.303H158.53c-1.385,0-2.73,0.095-3.998,0.284c-0.056,0.009-0.111,0.016-0.166,0.024 c-6.411,0.879-12.471,3.89-17.059,8.48L80.761,94.898c-5.667,5.666-8.787,13.203-8.787,21.222v343.015 c0,12.848,10.452,23.303,23.301,23.303h321.451c12.848,0,23.301-10.453,23.301-23.303v-48.669c0-8.162,6.619-14.781,14.781-14.781 c8.162,0,14.781,6.619,14.781,14.781v48.669C469.587,488.285,445.872,512,416.725,512z"
          ></path>{" "}
        </g>{" "}
        <path
          style={{ fill: "transparent" }}
          d="M152.361,15.225v481.992H95.275c-21.032,0-38.084-17.052-38.084-38.084V116.121 c0-11.881,4.711-23.269,13.117-31.676l56.546-56.546C133.787,20.967,142.763,16.542,152.361,15.225z"
        ></path>{" "}
        <g>
          {" "}
          <path
            style={{ fill: "currentColor" }}
            d="M152.359,512H95.274c-29.149,0-52.864-23.715-52.864-52.865V116.121 c0-15.918,6.196-30.878,17.448-42.127l56.544-56.547c9.127-9.126,21.183-15.115,33.951-16.864 c4.222-0.585,8.505,0.698,11.723,3.505c3.219,2.807,5.066,6.869,5.066,11.139v481.992C167.141,505.381,160.523,512,152.359,512z M137.578,38.083c-0.092,0.089-0.182,0.179-0.272,0.269L80.761,94.898c-5.667,5.666-8.787,13.203-8.787,21.222v343.015 c0,12.848,10.452,23.303,23.301,23.303h42.304V38.083H137.578z"
          ></path>{" "}
          <path
            style={{ fill: "currentColor" }}
            d="M371.291,340.263H152.359c-8.162,0-14.781-6.619-14.781-14.781s6.619-14.781,14.781-14.781h218.932 c8.162,0,14.781,6.619,14.781,14.781S379.455,340.263,371.291,340.263z"
          ></path>{" "}
          <path
            style={{ fill: "currentColor" }}
            d="M371.291,253.784H152.359c-8.162,0-14.781-6.619-14.781-14.781c0-8.162,6.619-14.781,14.781-14.781 h218.932c8.162,0,14.781,6.619,14.781,14.781C386.073,247.164,379.455,253.784,371.291,253.784z"
          ></path>{" "}
          <path
            style={{ fill: "currentColor" }}
            d="M371.291,426.743H152.359c-8.162,0-14.781-6.619-14.781-14.781s6.619-14.781,14.781-14.781h218.932 c8.162,0,14.781,6.619,14.781,14.781S379.455,426.743,371.291,426.743z"
          ></path>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};

export default ExamIcon;
